 <template>
	<v-container class="noMargin">	    
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1">					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>VEHICLES</h2>
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque a nulla mauris. Vestibulum augue enim, aliquam eget mi sit amet, mattis tempus risus. Vivamus blandit pretium lorem eu placerat. Aenean tincidunt lobortis massa, non viverra nibh volutpat ac. Maecenas sed bibendum neque. Cras et nisl tortor.</p>
				</div>	
				<v-btn @click.prevent="fncAddVehicle" class="elevation-5" color="info"><i class="material-icons">add</i>Create Vehicle</v-btn>				
				<v-btn @click.prevent="fncReloadVehicles" class="elevation-5" color="info"><i class="material-icons">refresh</i>Reload</v-btn>
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
          fncAddVehicle() {
            this.$store.dispatch({
              type: 'setObjVehicleAdd'
            });
				var modalDetails = { title: 'Add Vehicle', component: 'modal-vehicle-add', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
          fncReloadVehicles() {            
            this.$store.dispatch({
              type: 'fncPopulateVehicles',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>